import { render, staticRenderFns } from "./aRmsStrategyAvailabilityColumns.vue?vue&type=template&id=5d8f5bf8&scoped=true"
import script from "./aRmsStrategyAvailabilityColumns.vue?vue&type=script&lang=js"
export * from "./aRmsStrategyAvailabilityColumns.vue?vue&type=script&lang=js"
import style0 from "./aRmsStrategyAvailabilityColumns.vue?vue&type=style&index=0&id=5d8f5bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f5bf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VChip,VCol,VIcon,VRow,VTooltip})
